import { render, staticRenderFns } from "./GradientPoints.vue?vue&type=template&id=7ee30bfb&"
import script from "./GradientPoints.vue?vue&type=script&lang=ts&"
export * from "./GradientPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports